/**
 * Herkunft eines Besuchers aus der URL lesen und ueber den Buchungsvorgang
 * hinweg merken.
 *
 * Warum sessionStorage und kein Cookie: Ein Cookie waere einwilligungspflichtig
 * und wuerde die Buchungsseite um ein Banner erweitern. Der sessionStorage
 * lebt nur fuer diesen Besuch, genau so lange wie der Buchungsvorgang.
 *
 * Warum ueberhaupt gemerkt: Der Buchungsvorgang geht ueber mehrere Schritte,
 * bei Anzahlung sogar ueber Stripe und zurueck. Die UTM-Parameter stehen aber
 * nur beim allerersten Aufruf in der URL.
 */

const SPEICHER = "mib_acquisition";

/** Muss zu ACQUISITION_SOURCE_CHOICES passen. */
function kanalAus(params, referrer) {
  const utm = String(params.get("utm_source") || "").toLowerCase().trim();

  // Klick-Kennungen sind eindeutig: sie entstehen nur bei bezahlten Klicks.
  if (params.get("fbclid")) return "facebook";
  if (params.get("gclid")) return "google";

  if (utm) {
    if (utm.includes("instagram") || utm === "ig") return "instagram";
    if (utm.includes("facebook") || utm === "fb" || utm.includes("meta")) return "facebook";
    if (utm.includes("google") || utm === "adwords") return "google";
    if (utm.includes("whatsapp")) return "whatsapp";
    return "other";
  }

  const ref = String(referrer || "").toLowerCase();
  if (!ref) return "";
  if (ref.includes("instagram.")) return "instagram";
  if (ref.includes("facebook.") || ref.includes("fb.")) return "facebook";
  if (ref.includes("google.")) return "google";
  if (ref.includes("whatsapp") || ref.includes("wa.me")) return "whatsapp";

  // Ein Verweis von irgendwoher ist keine Herkunft. Wer direkt auf die
  // Buchungsseite geht, kann von ueberall kommen - "Website" hineinzuschreiben
  // waere erfunden, und erfundene Herkunft ist schlechter als keine: dann
  // verschiebt jemand Werbebudget auf Basis von Zahlen, die niemand gemessen hat.
  return "";
}

/**
 * Liest die Herkunft aus der uebergebenen URL und legt sie ab, falls noch
 * keine gespeichert ist. Der erste Kontakt gewinnt.
 */
export function erfasseHerkunft(suchstring, referrer) {
  try {
    if (sessionStorage.getItem(SPEICHER)) return leseHerkunft();
    const params = new URLSearchParams(suchstring || "");
    // Im eingebetteten Buchungsbutton laeuft die Seite in einem iframe auf
    // einer anderen Domain. Der eigene document.referrer ist dort die
    // Praxisseite selbst und damit wertlos. embed.js reicht deshalb den
    // echten Verweis der Elternseite als Parameter durch.
    const source = kanalAus(params, params.get("parent_referrer") || referrer);
    if (!source) return null;

    const daten = {
      acquisition_source: source,
      acquisition_campaign: params.get("utm_campaign") || null,
      acquisition_medium: params.get("utm_medium") || null,
      acquisition_click_id: params.get("fbclid") || params.get("gclid") || null,
    };
    sessionStorage.setItem(SPEICHER, JSON.stringify(daten));
    return daten;
  } catch (_e) {
    return null; // privater Modus, Speicher voll: eine Buchung darf daran nie scheitern
  }
}

/** Gibt die gemerkte Herkunft zurueck, oder ein leeres Objekt. */
export function leseHerkunft() {
  try {
    const roh = sessionStorage.getItem(SPEICHER);
    return roh ? JSON.parse(roh) : {};
  } catch (_e) {
    return {};
  }
}
